module.exports = __webpack_public_path__ + "static/media/19ESCAP15.6200af3b.jpg";